import { render } from "./News.vue?vue&type=template&id=10683858&scoped=true"
const script = {}

import "./News.vue?vue&type=style&index=0&id=10683858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10683858"]])

export default __exports__